<div style="text-align: right;">
</div>
<form>
 <!-- spinner -->
 <div class="spinner-wrapper text-center" [ngClass]="{'show': loadingDemoApp}">
  <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
</div><!-- /spinner -->
  <div>
  </div>
</form>
